export default __webpack_public_path__ + "static/media/male.9d65f762.png";